module.exports = __webpack_public_path__ + "addeparStep2PortfolioName.4696d0bc5be8938c3154cca27120f20e.png";